<template>
  <div class="containerNcm">   
    <div class="painel2">
      <img src="/arqlef/arqlef2.svg" alt="" />
    </div>
    <div class="conteudoCadastrar">
      <p class="titulocadastrar">Cadastrar nova empresa</p>    
      <form @submit.prevent="cadastrar">
        <div>
          <div class="groupcampo">
            <input
              type="text"
              v-model="cnpj"
              placeholder="CNPJ da empresa"
              maxlength="18"
            />
            <img src="/arqlef/pesquisar.svg" alt="" />
          </div>
          <select placeholder="UF" id="uf" type="text" style="width: 250px;">
            <option value="UF">UF</option>
            <option :value="e.codigo" v-for="(e, i) in estados" :key="i">
              {{ e.uf }}
            </option>
          </select>
        </div>
        <div class="groupcampo2">
          <input
            type="text"
            v-model="razaosocial"
            placeholder="Razão Social da empresa"
          />
          <img src="/arqlef/pesquisar.svg" alt="" />
        </div>
        <p v-if="msgCadastrar" style="color:red;text-align:center;margin-top:30px;position:relative;">{{msgCadastrar}}</p>
        <div class="acoes">
          <span @click="limpar">Limpar campos</span>
          <button type="submit">+ Adicionar nova empresa</button>
        </div>
        <br>
        <br>
      </form>  
    </div>
    <vue-topprogress ref="topProgress"></vue-topprogress>
    <CadCertificado> </CadCertificado>
  </div>
</template>

<script>
import config from "../services/config.js";
import { vueTopprogress } from "vue-top-progress";
import CadCertificado from '../shared/CadCertificado.vue'
import barramento from '@/services/barramento'
export default {
  components: { vueTopprogress,CadCertificado },
  data() {
    return {     
      estados: [],
      cnpj: "",
      razaosocial: "",
      msgCadastrar:""   
    };
  },
  methods: {   
    async buscarEstados() {
      this.estados = await config.consultarEstado();
    },
    verificarStatus(status,campo){
        if(status.status>=400){       
          this[campo] = status.data.message;
        }else{
          this.limpar();
          this.$store.state.razaoSocial = status.razaoSocial
          this.$store.state.idEmpresa =  status.idEmpresa
          console.log( this.$store.state)
          barramento.$emit('acionarModalDeListaEmpresa')
          console.log(status)
        }
    },
    async cadastrar() {
      this.msgCadastrar = "";
      if (this.razaosocial.length == 0) {
        this.msgCadastrar = "Campo razão social não preenchido";
      } else if (this.cnpj == 0) {
        this.msgCadastrar = "Campo CNPJ não preenchido";
      } else {
         console.log(this.$store.state.idCliente)
        this.$refs.topProgress.start();
        this.cnpj = this.cnpj.replace(/(\.)/g, "").toString();
        let uf = document.getElementById("uf").value;
        let status = await config.cadastrarEmpresa({
          razaoSocial: this.razaosocial.trim(),
          cnpj: this.cnpj
            .replace("/", "")
            .replace("-", "")
            .trim(),
          uf: uf,
         
          idCliente: this.$store.state.idCliente,
        });
        this.verificarStatus(status,"msgCadastrar");
        this.$refs.topProgress.done();        
      }
    },   
    limpar() {   
      this.msgCadastrar = "";
      this.razaosocial = "";
      this.cnpj = "";
    },
    continuar(id) {
      this.$store.state.idEmpresa = id;
      sessionStorage.setItem("idEmpresaLef", id);
      this.$router.push({
        name: "minhasnotas",
      });
    },
  },
  watch: {
    cnpj(n, a) {
      if (this.cnpj.length == 2 && n[n.length - 1] != "." && a.length != 3) {
        this.cnpj = this.cnpj.replace(/(\d{2})/, "$1.");
      } else if (
        this.cnpj.length == 6 &&
        n[n.length - 1] != "." &&
        a.length != 7
      ) {
        this.cnpj = this.cnpj.replace(/(\d{2})\.(\d{3})/, "$1.$2.");
      } else if (
        this.cnpj.length == 10 &&
        n[n.length - 1] != "/" &&
        a.length != 11
      ) {
        this.cnpj = this.cnpj.replace(/(\d{2})\.(\d{3})\.(\d{3})/, "$1.$2.$3/");
      } else if (
        this.cnpj.length == 16 &&
        n[n.length - 1] != "-" &&
        a.length != 17
      ) {
        this.cnpj = this.cnpj.replace(
          /(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})/,
          "$1.$2.$3/$4-"
        );
      }
      this.cnpj = this.cnpj.replace(/[A-Za-z]/g, "");
    },
  },
  created() {
    document.documentElement.scrollTop = 0;
    this.buscarEstados();
    
  },
};
</script>

<style>
.conteudoCadastrar {
  max-width: 900px;
  margin: 0px auto;
  text-align: left;
}
.conteudoCadastrar .titulocadastrar {
  color: #000;
  font-size: 1.8em;
  font-weight: bold;
  margin-top: 100px;
  margin-bottom: 75px;
  text-align: center;
}
.conteudoCadastrar .tituloc {
  color: #707070;
  font-weight: bold;
  margin-top: 25px;
}

.conteudoCadastrar form div {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.acoes {
  display: flex;
  justify-content: center !important;
  align-items: center;
  margin-top: 105px;
  margin-bottom: 28px;
}
.acoes button {
  width: 240px;
  height: 40px;
  border-radius: 10px;
  color: #fff;
  background: #009188;
  border: none;

  font-size: 15px;
}
.acoes button {
  outline: none;
}
.acoes span {
  margin-right: 30px;
  color: #707070;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
}
.conteudoCadastrar form select {
  height: 44px;
  border: 1px solid #707070;
  border-radius: 5px;
  padding-left: 10px;
}
.conteudoCadastrar form select:focus {
  outline: none;
}
.conteudoCadastrar form .groupcampo {
  position: relative;
  max-width: 690px;
  width: 100%;
  margin-right: 20px;
}
.conteudoCadastrar form .groupcampo2 {
  position: relative;
  width: 100%;
  margin-right: 20px;
  margin-top: 45px;
}
.conteudoCadastrar form .groupcampo2 input {
  height: 44px;
  border: 1px solid #707070;
  border-radius: 5px;
  padding: 0px 40px 0px 10px;
  width: 100%;
}
.conteudoCadastrar form .groupcampo2 input {
  outline: none;
}
.conteudoCadastrar form .groupcampo2 img {
  position: absolute;
  right: 15px;
  top: 12px;
}
.conteudoCadastrar form .groupcampo input {
  height: 44px;
  border: 1px solid #707070;
  border-radius: 5px;
  padding: 0px 40px 0px 10px;
  width: 100%;
}
.conteudoCadastrar form .groupcampo input:focus {
  outline: none;
}
.conteudoCadastrar form .groupcampo img {
  position: absolute;
  right: 15px;
  top: 12px;
}
</style>
